<template>
    <b-form-group
        :label="label"
        :invalid-feedback="error"
        :state="state"
    >
        <b-badge
            v-for="(option, index) in options"
            pill
            class="badge-select badge-circle-select mr-2"
            :class="{ 'low-opacity': !value.includes(option.value) }"
            :variant="value.includes(option.value) ? 'primary' : 'secondary'"
            :key="index"
            @click="handleBadgeClick(option.value)"
        >
            {{ option.text }}
        </b-badge>
    </b-form-group>
</template>

<script>
    export default {
        name: 'FormBadgeSelect',
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            label: {
                type: String,
                default: null,
            },
            error: {
                type: String,
                default: null,
            },
            options: {
                type: Array,
                default: () => [],
            },
            readonly: {
                type: Boolean,
                default: false,
            },            
        },
        computed: {
            state() {
                if (this.error) {
                    return !this.error;
                }
            },
        },
        methods: {
            handleBadgeClick(value) {
                if (this.readonly) {
                    return;
                }
                if (this.value.includes(value)) {
                    this.$emit('input', this.value.filter(v => v !== value));
                } else {
                    this.$emit('input', this.value.concat([value]));
                }
            }
        }
    };
</script>

<style lang="scss" scoped>

    .badge-select {
        cursor: pointer;
    }

    .badge-circle-select {
        width: 2rem !important;
        line-height: 2.1 !important;
    }

    .low-opacity {
        opacity: 60%;
    }

</style>